import { Avatar, Box, Button, Grid2, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Constants, Page_Padding } from '../../shared/constants'
import CustomDivider from '../../shared/utils/CustomDivider'
import DominoPrizeCard from '../../shared/components/DominoPrizeCard'
import { CustomButtonContained } from '../../shared/utils/CustomButton'
import { useNavigate } from 'react-router-dom'
import { useGetLeaderBoardWinners } from '../../assets/api/useGetApi'
import useResponsive from '../../shared/utils/Responsive'
import { DataGrid } from '@mui/x-data-grid'
import ToggleSwitch from '../../shared/utils/CustomToggle'
import CustomDataGrid from '../../shared/components/CustomDataGrid'
import SelectBoxField from '../../shared/components/FormFields/SelectBoxField'

const FinalPriveTypeFive = () => {
    const [showActiveOnly, setShowActiveOnly] = useState(false);
    const [filters, setFilters] = useState({});
    const { data: winnersList, isLoading } = useGetLeaderBoardWinners({
        ...(filters || {}),
        ...(showActiveOnly ? {} : { only_winners: true })
    });
    const handleToggleChange = (isChecked) => {
        setShowActiveOnly(isChecked);
    };
    const winnerListRow = winnersList?.data?.map((item, index) => ({
        id: index + 1,
        ...item
    })) || [];
    const isSmallScreen = useResponsive('sm')
    const isMediumScreen = useResponsive('md')
    const navigate = useNavigate()

    const apartmentSet = new Set(
        winnersList?.data?.map((item) => item?.apartment).filter(Boolean) // filter out null/undefined
    );

    const ApartmentOptions = Array.from(apartmentSet).map((apartment) => ({
        id: apartment,
        label: apartment,
        value: apartment,
    }));

    const prizeData = [
        {
            prizeImg: Constants.customImages.PrizeOneImg,
            content: "A safe and fun scooter designed for indoor use. With smooth wheels and a sturdy frame, it's perfect for kids to zoom around the house",
            prizeLogo: Constants.customImages.SecondPrize,
            marginTop: "0"

        },
        {
            prizeImg: Constants.customImages.PrizeTowImg,
            content: "A fast-paced tabletop game where players control miniature footballers to kick the ball into the opponent's goal",
            prizeLogo: Constants.customImages.FirstPrize,
            marginTop: isMediumScreen ? "0" : "-20vh"

        },
        {
            prizeImg: Constants.customImages.PrizeThreeImg,
            content: "A colorful and lightweight backpack designed just for kids. Great for carrying books, snacks, or toys — ideal for school, outings, or playdates.",
            prizeLogo: Constants.customImages.ThirdPrize,
            marginTop: "0"

        },
    ]

    const ruleData = [
        {
            content: [
                {
                    title: "Team Size",
                    text: "Individual participant."
                },
                {
                    title: "Time Limit",
                    text: "Maximum setup time is 3 minutes."
                },
                {
                    title: "Trigger Mechanism",
                    text: "The fall must be initiated by a single touch or action (no pushing mid-way)."
                },
                {
                    title: "Material Restrictions",
                    text: "Cards will be given by MySkill"
                },
            ]
        },
        {
            heading: " Scoring Criteria",
            content: [
                {
                    title: "Total Cards",
                    text: "Maximum of 100 cards will be given to each participant Count of successfully fallen cards will be considered"
                },
                {
                    title: "Time to Complete Fall ",
                    text: "Shorter fall times are rewarded.( max 3 mins)"
                },
                {
                    title: "Design Complexity",
                    text: "Spiral Structure"
                },
                {
                    title: "Clean Execution",
                    text: "No resets or re-starts allowed during final run and unfallen segments will be noted and not considered"
                },
            ]
        },
        {
            heading: "Disqualifications",
            content: [
                {
                    text: "Touching/moving dominos during the final run."
                },
                {
                    text: "Use of unapproved props or tools."
                },
                {
                    text: "Exceeding the setup time limit."
                },
                {

                    text: "Any unsafe or disruptive behavior."
                },
            ]
        },
        {
            heading: "Leaderboard Guidelines",
            content: [
                {
                    text: "In case of a tie, time taken to set up  may be considered."
                },
                {
                    text: "Judges’ decisions are final and binding."
                },
                {
                    text: "First, second and third winners are awarded and Top 10 will be mentioned on the leader board"
                }
            ]
        },
    ]




    const contactPersonColumns = [
        {
            field: "childs name",
            headerName: "Student's Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2} textAlign={"center"} fontSize={"12px"}  >{params.value}</Typography>,
        },
        {
            field: "parents name",
            headerName: "Parent's Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2} textAlign={"center"} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "childs age",
            headerName: "Age",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2} textAlign={"center"} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "apartment",
            headerName: "Apartment",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2} textAlign={"center"} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "no of card",
            headerName: "No Of Card",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2} textAlign={"center"} fontSize={"12px"}>{params.value}</Typography>,


        },
        {
            field: "no of card fell",
            headerName: "No Of Card Fell",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2} textAlign={"center"} fontSize={"12px"}>{params.value}</Typography>,


        },
        {
            field: "time",
            headerName: "Time Taken",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2} textAlign={"center"} fontSize={"12px"}><CustomButtonContained buttonText={`${params.value} Min`} /></Typography>,


        },
    ];


    const handleChangeApartment = (value) => {
        setFilters(prevFilter => ({
            ...prevFilter,
            apartment: value
        }));
    };
    return (
        <Box>

            <Box
                sx={{
                    width: '100%',
                    backgroundImage: `url(${Constants.customImages.DominoHeroImg})`, // or public URL
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    aspectRatio: isSmallScreen ? '16/20' : '16/8',
                    zIndex: 100, position: 'relative',

                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                }}
            >
                <Box px={Page_Padding}>
                    <Typography variant={isSmallScreen ? "h5" : "h4"} color='primary.main'> Experience the Thrill of the Fall !</Typography>
                    <CustomDivider size={"0.5rem"} />
                    <Typography variant='body1' color='primary.main'>Join the ultimate Domino Fall challenge where strategy meets creativity — Set up your dominoes, master the perfect chain reaction, and watch your masterpiece come alive in a breathtaking tumble!</Typography>
                    <CustomDivider size={"0.5rem"} />
                    <Typography variant='body1' color='red.main' fontWeight={600}>Ready to take the first domino step? Let the fun begin!</Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    bgcolor: "#4F464B",
                    width: "100%",
                    height: "20vh",
                    mt: "-20vh",
                    zIndex: -5,
                    position: 'relative',
                }}
            />

            <Box
                sx={{
                    width: '100%',
                    backgroundImage: `url(${Constants.customImages.DominoBrick})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: "100vh",
                    bgcolor: "#4F464B",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    pt: "10vh"
                }}
            >
                <Box
                    component={"img"}
                    src={Constants.customImages.BlockPuttingHand}
                    width={"22vw"}
                    sx={{
                        position: "absolute",
                        right: "0",
                        top: "-20vh",
                        zIndex: 2

                    }}
                />

                <Box px={Page_Padding}
                    sx={{ position: "relative", zIndex: 100 }}
                >
                    <Typography variant={isSmallScreen ? "h5" : "h4"} color='primary.main'>Domino Falls</Typography>
                    <CustomDivider size={"0.5rem"} />
                    <Typography variant='body1' color='primary.main'>
                        Welcome to Domino Fall, the ultimate game where one simple push sets off a mesmerizing chain reaction! Carefully plan your path, arrange your dominoes, and tip the first tile to watch a stunning wave of motion take over. It's more than just a game—it's a mix of art, science, and fun, designed to challenge the mind and spark imagination.Whether you're building tall towers, creating loops and bridges, or forming colorful patterns, every fall is a celebration of patience, precision, and creativity. Kids of all ages will love the thrill of seeing their creations come to life with just one push.
                    </Typography>
                    <CustomDivider size={"0.5rem"} />
                </Box>
            </Box>


            <Box
                sx={{
                    width: '100%',
                    backgroundImage: `url(${Constants.customImages.DominoWhiteBg})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: "relative",
                    mt: "-20vh",
                    zIndex: 99,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    aspectRatio: '16/8',
                }}
            >
                <Typography variant='h5' fontWeight={300} textAlign={"center"}>DISCOVER THE </Typography>
                <CustomDivider size={"1rem"} />
                <Typography variant='h1' color='red.main' textAlign={"center"}>WINNERS PRIZE </Typography>

            </Box>
            <Box
                sx={{
                    px: Page_Padding,
                    zIndex: 100,
                    position: "relative"

                }}

            >
                <Grid2 container spacing={"2rem"}>
                    {
                        prizeData?.map((item, index) => (
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                                <DominoPrizeCard item={item} />
                            </Grid2>

                        ))
                    }
                </Grid2>
            </Box>
            <Box>
                <Box
                    component={"img"}
                    src={Constants.customImages.DominoBoys}
                    width={"10vw"}
                    sx={{ margin: "auto", display: "block" }}
                />
                <Box

                    sx={{ border: "1px solid #CCCCCCCC", width: "70%", margin: "auto", display: "block" }}
                />
            </Box>
            <CustomDivider />
            <Box px={Page_Padding}>
                <Grid2 container spacing={"2rem"} sx={{display:"flex",justifyContent:"flex-end"}}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                        <SelectBoxField
                            label="Select Apartment"
                            options={ApartmentOptions}
                            isRequired={true}
                            onChange={handleChangeApartment}
                            isShow={true}
                            isloading={isLoading}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        
                            <ToggleSwitch checked={showActiveOnly} onCheck={handleToggleChange} unCheckedText={"Winners Only"} checkedText={"All"} />
                      
                    </Grid2>
                </Grid2>


                <CustomDivider />
                <CustomDataGrid
                    rows={winnerListRow}
                    columns={contactPersonColumns}
                    isLoading={isLoading}

                />

                {/* <DataGrid
                   
                    sx={{
                        border: "none",
                        ".MuiDataGrid-cell, .MuiDataGrid-columnHeader": {
                            outline: "none",
                        },
                    }}
                /> */}

                {/* <Grid2 container sx={{ bgcolor: "#F9F9F9", p: "1rem" }}>
                    <Grid2 size={2}>
                        <Typography variant='body2' textAlign={"center"}>Rank</Typography>
                    </Grid2>
                    <Grid2 size={3}>
                        <Typography variant='body2' pl={3}>Name</Typography>
                    </Grid2>
                    <Grid2 size={2}>
                        <Typography variant='body2' textAlign={"center"}>Apartment</Typography>
                    </Grid2>
                    <Grid2 size={3}>
                        <Typography variant='body2' textAlign={"center"}>Number of cards</Typography>
                    </Grid2>
                    <Grid2 size={2}>
                        <Typography variant='body2' textAlign={"center"}>Time Taken</Typography>
                    </Grid2>
                </Grid2>
                {
                    rankTable.map((item, index) => (
                        <Grid2 container sx={{ bgcolor: item?.bgcolor, p: "1rem" }}>
                            <Grid2 size={2}>

                                <Typography variant='body2' textAlign={"center"}>{item?.rank}</Typography>
                            </Grid2>
                            <Grid2 size={3}>
                                <Box sx={{ display: "flex", justifyContent: "start", alignItems: "center", gap: 0.5 }}>
                                    <Avatar src={item?.personImg} sx={{ width: "20px", height: "20px" }} />
                                    <Typography variant='body2'>{item?.name}</Typography>
                                </Box>
                            </Grid2>
                            <Grid2 size={2}>
                                <Typography variant='body2' textAlign={"center"}>{item?.apartment}</Typography>
                            </Grid2>
                            <Grid2 size={3}>
                                <Typography variant='body2' textAlign={"center"}>124</Typography>
                            </Grid2>
                            <Grid2 size={2} textAlign={"center"}>  <CustomButtonContained buttonText={item.timeTaken} /></Grid2>
                        </Grid2>
                    ))
                } */}


            </Box>
            <CustomDivider />
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant='outlined' style={{ margin: "auto" }}>Click to see completed challenges</Button>
            </Box>

            <CustomDivider />
            <Box

                sx={{
                    backgroundImage: `url(${Constants.customImages.DominoRuleTopSection})`, // or public URL
                    backgroundSize: '100% auto',
                    backgroundPosition: "end",
                    backgroundRepeat: 'no-repeat',
                    aspectRatio: '16/5',
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center"
                }}
            >
                <Typography variant='h6' textAlign={"center"}>Catch the action live with all the details below</Typography>
                <CustomDivider size={"1rem"} />
                <Typography variant={isSmallScreen ? "h5" : "h3"} color='red.main' textAlign={"center"}>Next Big Game – Don’t Miss It!</Typography>

            </Box>
            <Box
                sx={{
                    backgroundImage: `url(${Constants.customImages.DominoLightBlocks})`, // or public URL
                    backgroundSize: 'contain',
                    backgroundPosition: 'bottom right',

                    backgroundRepeat: 'no-repeat',
                    bgcolor: "#FAC482",
                    pb: "10vh"
                }}
            >
                <Box px={Page_Padding}>

                    <CustomDivider />
                    <Box
                        sx={{
                            width: "100%",
                            backgroundImage: `url(${Constants.customImages.DominoRulesCardImg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: "center",
                            backgroundRepeat: 'no-repeat',
                            height: "300px",
                            borderRadius: "2rem",

                        }}
                    ><Box
                        sx={{
                            padding: "2rem 2rem"
                        }}
                    >
                            <Typography variant={isSmallScreen ? "h5" : "h4"} color='primary.main' mb={0.5}>Happening in ur society. Join Us</Typography>
                            <Typography variant='h6' color='primary.main' fontWeight={200}>The stage is set, the dominos are ready—are you?</Typography>
                            <CustomDivider size={"1rem"} />
                            <Button variant={"contained"} onClick={() => { navigate("/CoursesDetail/mission-domino-fall-685d2c4923625") }}>Take up the challenge</Button>
                            <CustomDivider size={"1.5rem"} />
                            <Box sx={{ display: 'flex', alignItems: "center", gap: "1rem" }}>
                                <Typography variant='body2' color='primary.main' fontWeight={200}>Exciting prizes awaits you</Typography>
                                <Box component={"img"} src={Constants.customImages.ArrowMarkLight} alt='arrow-mark' sx={{ width: "6vw" }} />
                            </Box>

                        </Box>
                    </Box>
                    <CustomDivider />
                    <Typography variant="h5" textAlign={"center"}>Rules and Regulations</Typography>
                    {
                        ruleData?.map((item, index) => (
                            <Box key={index} sx={{ my: "2rem" }}>
                                {item?.heading && <Box sx={{ display: 'flex', alignItems: "center", gap: "1rem" }}>
                                    <Box component={"img"} src={Constants.customImages.ArrowMark} alt='arrow-mark' sx={{ width: "6vw" }} />
                                    <Typography variant={isSmallScreen ? "body1" : "h5"}>{item?.heading}</Typography>
                                </Box>}

                                <CustomDivider size={"1rem"} />
                                {
                                    item?.content?.map((item, index) => (
                                        <Box key={index} sx={{ display: "flex", my: 1 }}>
                                            {item?.title && <Typography variant={isSmallScreen ? "body2" : "body1"}>{item?.title} : {""} </Typography>}
                                            <Typography variant={isSmallScreen ? "body2" : "body1"} color='#282828' fontWeight={300}> {item?.text}</Typography>
                                        </Box>
                                    ))
                                }

                            </Box>
                        ))
                    }
                </Box>

            </Box>
        </Box>
    )
}

export default FinalPriveTypeFive